module.exports = __webpack_public_path__ + "img/12.dc804de1.jpg";